import { useState, useRef, useEffect, useCallback } from "react";

const LOGO_WHITE = "data:image/png;base64,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";
const LOGO_GOLD  = "data:image/png;base64,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";
const LOGO_ON_WHITE = "data:image/png;base64,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";

// ── Config ─────────────────────────────────────────────────────────────────
const API_URL       = "https://d9gp4dwpjw4in.cloudfront.net";
const PANEL_URL     = "https://star-standard-content.s3.amazonaws.com/mapper-panel.json";
const COGNITO_URL   = "https://cognito-idp.us-east-2.amazonaws.com/";
const POOL_ID       = "us-east-2_behl3sU6w";
const CLIENT_ID     = "2vfe8cmjtrh3ro424mlkp1e9nt";
const REGION        = "us-east-2";

const CONFIDENCE_COLORS = {
  HIGH:     { bg: "rgba(74,222,128,.12)", border: "rgba(74,222,128,.4)",  text: "#4ade80", label: "HIGH" },
  MEDIUM:   { bg: "rgba(251,191,36,.12)", border: "rgba(251,191,36,.4)",  text: "#fbbf24", label: "MEDIUM" },
  LOW:      { bg: "rgba(96,165,250,.12)", border: "rgba(96,165,250,.4)",  text: "#60a5fa", label: "LOW" },
  NO_MATCH: { bg: "rgba(248,113,113,.08)", border: "rgba(248,113,113,.3)", text: "#f87171", label: "NO MATCH" },
};

// ── Auth helpers ────────────────────────────────────────────────────────────
async function cognitoAuth(username, password) {
  const r = await fetch(COGNITO_URL, {
    method: "POST",
    headers: { "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityProviderService.InitiateAuth" },
    body: JSON.stringify({
      AuthFlow: "USER_PASSWORD_AUTH",
      ClientId: CLIENT_ID,
      AuthParameters: { USERNAME: username, PASSWORD: password },
    }),
  });
  return r.json();
}

async function cognitoNewPassword(username, newPassword, session) {
  const r = await fetch(COGNITO_URL, {
    method: "POST",
    headers: { "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityProviderService.RespondToAuthChallenge" },
    body: JSON.stringify({
      ChallengeName: "NEW_PASSWORD_REQUIRED",
      ClientId: CLIENT_ID,
      ChallengeResponses: { USERNAME: username, NEW_PASSWORD: newPassword,
                             "userAttributes.website": "https://mapper.starstandard.org",
                             "userAttributes.name": username },
      Session: session,
    }),
  });
  return r.json();
}

async function cognitoForgotPassword(username) {
  const r = await fetch(COGNITO_URL, {
    method: "POST",
    headers: { "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityProviderService.ForgotPassword" },
    body: JSON.stringify({ ClientId: CLIENT_ID, Username: username }),
  });
  return r.json();
}

async function cognitoConfirmForgotPassword(username, code, password) {
  const r = await fetch(COGNITO_URL, {
    method: "POST",
    headers: { "Content-Type": "application/x-amz-json-1.1",
                "X-Amz-Target": "AWSCognitoIdentityProviderService.ConfirmForgotPassword" },
    body: JSON.stringify({ ClientId: CLIENT_ID, Username: username,
                           ConfirmationCode: code, Password: password }),
  });
  return r.json();
}

// ── Login Screen ────────────────────────────────────────────────────────────
function LoginScreen({ onLogin }) {
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [newPwd, setNewPwd]     = useState("");
  const [confirmPwd, setConfirmPwd] = useState("");
  const [code, setCode]         = useState("");
  const [mode, setMode]         = useState("login");
  const [session, setSession]   = useState(null);
  const [error, setError]       = useState("");
  const [loading, setLoading]   = useState(false);
  const [panel, setPanel]       = useState(null);

  useEffect(() => {
    fetch(PANEL_URL).then(r => r.json()).then(setPanel).catch(() => {});
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try {
      const data = await cognitoAuth(email, password);
      if (data.ChallengeName === "NEW_PASSWORD_REQUIRED") {
        setSession(data.Session); setMode("new_password"); setLoading(false); return;
      }
      if (data.AuthenticationResult) {
        onLogin(data.AuthenticationResult.IdToken, email); return;
      }
      setError(data.message || data.__type || "Invalid email or password");
    } catch(e) { setError(e.message); }
    setLoading(false);
  };

  const handleNewPassword = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    if (newPwd !== confirmPwd) { setError("Passwords do not match"); setLoading(false); return; }
    try {
      const data = await cognitoNewPassword(email, newPwd, session);
      if (data.AuthenticationResult) { onLogin(data.AuthenticationResult.IdToken, email); return; }
      setError(data.message || data.__type || "Failed to set password");
    } catch(e) { setError(e.message); }
    setLoading(false);
  };

  const handleForgot = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try {
      const data = await cognitoForgotPassword(email);
      if (data.__type) { setError(data.message || data.__type); }
      else { setMode("reset_code"); }
    } catch(e) { setError(e.message); }
    setLoading(false);
  };

  const handleReset = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    if (newPwd !== confirmPwd) { setError("Passwords do not match"); setLoading(false); return; }
    try {
      const data = await cognitoConfirmForgotPassword(email, code, newPwd);
      if (data.__type) { setError(data.message || data.__type); }
      else { setMode("login"); setError("Password reset! Please sign in."); }
    } catch(e) { setError(e.message); }
    setLoading(false);
  };

  const styles = `
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { background: #1c1c2e; }
    .login-wrap { display: flex; min-height: 100vh; font-family: 'Inter', Arial, sans-serif; }
    .login-left { flex: 0 0 420px; background: #f8f7ff; display: flex; flex-direction: column;
                  justify-content: center; padding: 48px; border-right: 1px solid #e0dff0; }
    .login-right { flex: 1; background: #242438; display: flex; flex-direction: column;
                   justify-content: center; padding: 48px; }
    .login-logo { display: flex; flex-direction: column; align-items: flex-start; margin-bottom: 36px; }
    .login-logo-sub { font-size: 11px; color: #8884a8; font-family: monospace; letter-spacing: .1em; text-transform: uppercase; margin-top: 4px; }
    .login-title { font-size: 22px; font-weight: 700; color: #1c1c2e; margin-bottom: 6px; }
    .login-subtitle { font-size: 13px; color: #6b6b8a; margin-bottom: 28px; line-height: 1.5; }
    .login-label { font-size: 11px; font-weight: 600; color: #6b6b8a; text-transform: uppercase;
                   letter-spacing: .08em; margin-bottom: 6px; display: block; }
    .login-input { width: 100%; background: white; border: 1px solid #d0cee8; border-radius: 8px;
                   color: #1c1c2e; font-size: 14px; padding: 11px 14px; outline: none;
                   transition: border-color .2s; margin-bottom: 16px; font-family: inherit; }
    .login-input:focus { border-color: #c9a84c; }
    .login-btn { width: 100%; padding: 12px; border-radius: 8px; border: none; cursor: pointer;
                 font-size: 14px; font-weight: 600; font-family: inherit;
                 background: linear-gradient(135deg, #c9a84c, #b8943d); color: white;
                 transition: opacity .2s; margin-top: 4px; }
    .login-btn:hover { opacity: .88; }
    .login-btn:disabled { opacity: .5; cursor: not-allowed; }
    .login-error { background: rgba(239,68,68,.1); border: 1px solid rgba(239,68,68,.3);
                   border-radius: 6px; padding: 10px 14px; color: #dc2626; font-size: 13px;
                   margin-bottom: 16px; }
    .login-link { color: #c9a84c; cursor: pointer; font-size: 13px; text-decoration: none; }
    .login-link:hover { text-decoration: underline; }
    .login-hint { font-size: 12px; color: #8884a8; text-align: center; margin-top: 20px;
                  font-family: monospace; line-height: 1.6; }
    .panel-title { font-size: 26px; font-weight: 800; color: #c9a84c; margin-bottom: 8px; }
    .panel-sub { font-size: 14px; color: #b0aed0; margin-bottom: 28px; line-height: 1.6; }
    .panel-feature { display: flex; gap: 12px; margin-bottom: 16px; align-items: flex-start; }
    .panel-icon { font-size: 20px; flex-shrink: 0; margin-top: 1px; }
    .panel-feat-title { font-size: 14px; font-weight: 600; color: #f0eeff; }
    .panel-feat-desc { font-size: 12px; color: #8884a8; margin-top: 2px; line-height: 1.5; }
  `;

  const features = [
    { icon: "🗺️", title: "Upload any STAR XML Schema", desc: "Drop a .xsd file — we parse it instantly and resolve all $ref types against Components.xsd automatically" },
    { icon: "⚡", title: "AI-powered field matching", desc: "Voyage AI embeds every XML field and matches it to exact STAR JSON schema properties with confidence scores" },
    { icon: "🔍", title: "Three matches per field", desc: "See the top 3 candidate mappings with domain, schema, property name, and semantic similarity score" },
    { icon: "✨", title: "Claude explains each mapping", desc: "Enable AI explanations to get a plain-English justification for each HIGH and MEDIUM confidence match" },
    { icon: "⬇", title: "Export CSV or Excel", desc: "Download the complete mapping report for your team — same format as the existing STAR mapping workflow" },
  ];

  return (
    <div>
      <style>{styles}</style>
      <div className="login-wrap">
        <div className="login-left">
          <div className="login-logo">
            <img src={LOGO_ON_WHITE} alt="STAR" style={{height:36,objectFit:"contain",marginBottom:4}} />
            <div className="login-logo-sub">Schema Mapper</div>
          </div>

          {mode === "login" && (
            <form onSubmit={handleLogin}>
              <div className="login-title">Sign in</div>
              <div className="login-subtitle">Map STAR XML schemas to the JSON domain model</div>
              {error && <div className="login-error">{error}</div>}
              <label className="login-label">Email</label>
              <input className="login-input" type="email" value={email}
                onChange={e => setEmail(e.target.value)} placeholder="you@starstandard.org" required />
              <label className="login-label">Password</label>
              <input className="login-input" type="password" value={password}
                onChange={e => setPassword(e.target.value)} placeholder="••••••••" required />
              <button className="login-btn" type="submit" disabled={loading}>
                {loading ? "Signing in…" : "Sign in →"}
              </button>
              <div className="login-hint" style={{marginTop:16}}>
                <span className="login-link" onClick={() => { setMode("forgot"); setError(""); }}>
                  Forgot password?
                </span>
              </div>
            </form>
          )}

          {mode === "new_password" && (
            <form onSubmit={handleNewPassword}>
              <div className="login-title">Set your password</div>
              <div className="login-subtitle">Choose a permanent password for your account</div>
              {error && <div className="login-error">{error}</div>}
              <label className="login-label">New Password</label>
              <input className="login-input" type="password" value={newPwd}
                onChange={e => setNewPwd(e.target.value)} placeholder="Min 8 chars, upper, lower, number, symbol" required />
              <label className="login-label">Confirm Password</label>
              <input className="login-input" type="password" value={confirmPwd}
                onChange={e => setConfirmPwd(e.target.value)} placeholder="••••••••" required />
              <button className="login-btn" type="submit" disabled={loading}>
                {loading ? "Setting password…" : "Set password →"}
              </button>
            </form>
          )}

          {mode === "forgot" && (
            <form onSubmit={handleForgot}>
              <div className="login-title">Reset password</div>
              <div className="login-subtitle">Enter your email to receive a reset code</div>
              {error && <div className="login-error">{error}</div>}
              <label className="login-label">Email</label>
              <input className="login-input" type="email" value={email}
                onChange={e => setEmail(e.target.value)} placeholder="you@starstandard.org" required />
              <button className="login-btn" type="submit" disabled={loading}>
                {loading ? "Sending…" : "Send reset code →"}
              </button>
              <div className="login-hint" style={{marginTop:16}}>
                <span className="login-link" onClick={() => { setMode("login"); setError(""); }}>← Back to sign in</span>
              </div>
            </form>
          )}

          {mode === "reset_code" && (
            <form onSubmit={handleReset}>
              <div className="login-title">Enter reset code</div>
              <div className="login-subtitle">Check your email for the 6-digit code</div>
              {error && <div className="login-error">{error}</div>}
              <label className="login-label">Code</label>
              <input className="login-input" value={code}
                onChange={e => setCode(e.target.value)} placeholder="123456" required />
              <label className="login-label">New Password</label>
              <input className="login-input" type="password" value={newPwd}
                onChange={e => setNewPwd(e.target.value)} placeholder="Min 8 chars" required />
              <label className="login-label">Confirm Password</label>
              <input className="login-input" type="password" value={confirmPwd}
                onChange={e => setConfirmPwd(e.target.value)} placeholder="••••••••" required />
              <button className="login-btn" type="submit" disabled={loading}>
                {loading ? "Resetting…" : "Reset password →"}
              </button>
            </form>
          )}

          <div className="login-hint">Access provided by your STAR administrator.</div>
          <div style={{marginTop:16,padding:"10px 14px",background:"rgba(201,168,76,.08)",border:"1px solid rgba(201,168,76,.2)",borderRadius:8,fontSize:13,color:"#1a1a2e",fontWeight:500,textAlign:"center",lineHeight:1.6}}>
            ⚠️ <strong style={{color:"#c9a84c"}}>Beta Version</strong> — This platform is under active development.<br/>
            Mapping suggestions are AI-generated. If in doubt, verify with the STAR domain model team.
          </div>
        </div>

        <div className="login-right">
          <div className="panel-title">🗺️ STAR Schema Mapper</div>
          <div className="panel-sub">
            Instantly map your STAR XML schemas to the JSON domain model.<br/>
            Upload a .xsd file — get back exact field-level matches in seconds.
          </div>
          {features.map((f, i) => (
            <div className="panel-feature" key={i}>
              <div className="panel-icon">{f.icon}</div>
              <div>
                <div className="panel-feat-title">{f.title}</div>
                <div className="panel-feat-desc">{f.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ── Main App ────────────────────────────────────────────────────────────────
export default function App() {
  const [token, setToken]         = useState(() => localStorage.getItem("star_mapper_token") || "");
  const [userEmail, setUserEmail] = useState(() => localStorage.getItem("star_mapper_email") || "");
  const [xsdContent, setXsdContent] = useState("");
  const [fileName, setFileName]   = useState("");
  const [domain, setDomain]       = useState("");
  const [version, setVersion]     = useState("v1.2.0");
  const [useClaude, setUseClaude] = useState(false);
  const [expandComponents, setExpandComponents] = useState(false);
  const [results, setResults]     = useState(null);
  const [loading, setLoading]     = useState(false);
  const [error, setError]         = useState(null);
  const [filter, setFilter]       = useState("ALL");
  const [search, setSearch]       = useState("");
  const [versions, setVersions]   = useState([]);
  const [domains, setDomains]     = useState([]);
  const [progress, setProgress]   = useState(null);
  const fileRef = useRef(null);

  const authHeaders = { Authorization: `Bearer ${token}`, "Content-Type": "application/json" };

  const handleLogin = (tok, email) => {
    setToken(tok); setUserEmail(email);
    localStorage.setItem("star_mapper_token", tok);
    localStorage.setItem("star_mapper_email", email);
  };

  const handleLogout = () => {
    setToken(""); setUserEmail("");
    localStorage.removeItem("star_mapper_token");
    localStorage.removeItem("star_mapper_email");
  };

  useEffect(() => {
    if (!token) return;
    fetch(`${API_URL}/versions`, { headers: authHeaders })
      .then(r => r.json()).then(d => setVersions(d.versions || [])).catch(() => {});
    fetch(`${API_URL}/domains`, { headers: authHeaders })
      .then(r => r.json()).then(d => setDomains(d.domains || [])).catch(() => {});
  }, [token]);

  const handleFile = (file) => {
    if (!file) return;
    setFileName(file.name);
    const reader = new FileReader();
    reader.onload = e => setXsdContent(e.target.result);
    reader.readAsText(file);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) handleFile(file);
  };

  const runMapping = async () => {
    if (!xsdContent.trim()) { setError("Please upload an XSD file first"); return; }
    setLoading(true); setError(null); setResults(null);
    setProgress("Parsing XSD and resolving Components.xsd…");
    try {
      setProgress("Embedding fields and matching against STAR properties…");
      const r = await fetch(`${API_URL}/mapper/run`, {
        method: "POST", headers: authHeaders,
        body: JSON.stringify({
          xsd_content: xsdContent,
          domain: domain || null,
          version: version || null,
          use_claude: useClaude,
          expand_components: expandComponents,
          top_k: 3,
        }),
      });
      if (r.status === 401) { handleLogout(); return; }
      const data = await r.json();
      if (data.detail) { setError(data.detail); return; }
      setResults(data);
    } catch(e) { setError(`Mapping failed: ${e.message}`); }
    finally { setLoading(false); setProgress(null); }
  };

  const exportCSV = () => {
    if (!results) return;
    const headers = [
      "xml_path","xml_type","required","confidence","top_score","explanation",
      "match_1_domain","match_1_schema","match_1_property","match_1_ref","match_1_score","match_1_required","match_1_desc",
      "match_2_domain","match_2_schema","match_2_property","match_2_ref","match_2_score","match_2_required","match_2_desc",
      "match_3_domain","match_3_schema","match_3_property","match_3_ref","match_3_score","match_3_required","match_3_desc",
    ];
    const rows = results.results.map(r => {
      const base = {
        xml_path: r.xml_path, xml_type: r.xml_type,
        required: r.required ? "yes" : "no",
        confidence: r.confidence, top_score: r.top_score,
        explanation: r.explanation || "",
      };
      (r.matches || []).slice(0,3).forEach((m, i) => {
        base[`match_${i+1}_domain`]   = m.domain || "";
        base[`match_${i+1}_schema`]   = m.schema || "";
        base[`match_${i+1}_property`] = m.property || "";
        base[`match_${i+1}_ref`]      = m.ref || "";
        base[`match_${i+1}_score`]    = m.score || "";
        base[`match_${i+1}_required`] = m.required ? "yes" : "no";
        base[`match_${i+1}_desc`]     = m.description || "";
      });
      return base;
    });
    const csv = [headers.join(","),
      ...rows.map(r => headers.map(h => `"${(r[h]||"").toString().replace(/"/g,'""')}"`).join(","))
    ].join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `star_mapping_${fileName.replace(".xsd","")}_${version}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const filteredResults = (results?.results || []).filter(r => {
    if (filter !== "ALL" && r.confidence !== filter) return false;
    if (search && !r.xml_path.toLowerCase().includes(search.toLowerCase()) &&
        !(r.matches?.[0]?.property || "").toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  const STYLES = `
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=JetBrains+Mono:wght@400;600&display=swap');
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    :root {
      --bg:    #1c1c2e;
      --bg2:   #242438;
      --bg3:   #2a2a42;
      --bg4:   #32324e;
      --amber: #c9a84c;
      --amber-dim: rgba(201,168,76,.15);
      --text:  #f0eeff;
      --muted: #b0aed0;
      --dim:   #8884a8;
      --border:  #32324e;
      --border2: #3e3e5e;
      --green: #4ade80;
      --red:   #f87171;
      --blue:  #60a5fa;
      --yellow: #fbbf24;
      --mono: 'JetBrains Mono', monospace;
      --sans: 'Inter', Arial, sans-serif;
      --radius: 10px;
    }
    html, body, #root { height: 100%; background: var(--bg); }
    body { font-family: var(--sans); color: var(--text); }
    .app { display: flex; flex-direction: column; height: 100vh; }

    /* Topbar */
    .topbar { background: var(--bg2); border-bottom: 1px solid var(--border);
              padding: 0 24px; height: 56px; display: flex; align-items: center;
              justify-content: space-between; flex-shrink: 0; gap: 16px; }
    .topbar-left { display: flex; align-items: center; gap: 14px; }
    .topbar-logo { font-weight: 900; font-size: 18px; color: var(--amber); letter-spacing: -.02em; }
    .topbar-title { font-size: 13px; color: var(--muted); font-family: var(--mono); }
    .topbar-right { display: flex; align-items: center; gap: 12px; }
    .topbar-email { font-family: var(--mono); font-size: 11px; color: var(--dim); }
    .signout-btn { font-family: var(--mono); font-size: 10px; letter-spacing: .08em;
                   text-transform: uppercase; background: transparent;
                   border: 1px solid var(--border2); border-radius: 4px;
                   color: var(--dim); padding: 4px 10px; cursor: pointer; transition: all .2s; }
    .signout-btn:hover { border-color: var(--amber); color: var(--amber); }

    /* Layout */
    .layout { display: flex; flex: 1; overflow: hidden; min-height: 0; }
    .sidebar { width: 320px; background: var(--bg2); border-right: 1px solid var(--border);
               padding: 24px; overflow-y: auto; flex-shrink: 0; display: flex; flex-direction: column; gap: 20px; }
    .main { flex: 1; overflow-y: auto; padding: 24px; display: flex; flex-direction: column; gap: 16px; min-height: 0; }

    /* Sidebar sections */
    .section-title { font-family: var(--mono); font-size: 9px; letter-spacing: .12em;
                     text-transform: uppercase; color: var(--amber); margin-bottom: 10px; }
    .drop-zone { border: 2px dashed var(--border2); border-radius: var(--radius);
                 padding: 28px 16px; text-align: center; cursor: pointer; transition: all .2s; }
    .drop-zone:hover, .drop-zone.drag-over { border-color: var(--amber); background: var(--amber-dim); }
    .drop-icon { font-size: 28px; margin-bottom: 8px; }
    .drop-text { font-size: 13px; color: var(--text); font-weight: 600; margin-bottom: 4px; }
    .drop-hint { font-size: 11px; color: var(--dim); font-family: var(--mono); }
    .file-badge { background: var(--amber-dim); border: 1px solid rgba(201,168,76,.25);
                  border-radius: 6px; padding: 8px 12px; font-family: var(--mono);
                  font-size: 11px; color: var(--amber); display: flex; align-items: center; gap: 6px; }

    /* Controls */
    .ctrl-label { font-size: 11px; color: var(--muted); margin-bottom: 5px; display: block; font-weight: 500; }
    .ctrl-select { width: 100%; background: var(--bg3); border: 1px solid var(--border2);
                   border-radius: 7px; padding: 8px 10px; color: var(--text);
                   font-family: var(--mono); font-size: 11px; outline: none; cursor: pointer; }
    .ctrl-select:focus { border-color: var(--amber); }
    .toggle-row { display: flex; align-items: center; gap: 8px; }
    .toggle { width: 36px; height: 20px; background: var(--bg4); border-radius: 10px;
              cursor: pointer; position: relative; transition: background .2s; border: none; }
    .toggle.on { background: var(--amber); }
    .toggle::after { content: ""; position: absolute; width: 14px; height: 14px;
                     border-radius: 50%; background: white; top: 3px; left: 3px; transition: left .2s; }
    .toggle.on::after { left: 19px; }
    .toggle-label { font-size: 12px; color: var(--muted); flex: 1; }
    .toggle-warn { font-size: 10px; color: var(--dim); font-family: var(--mono); margin-top: 4px; }

    /* Run button */
    .run-btn { width: 100%; padding: 13px; border-radius: var(--radius); border: none;
               background: linear-gradient(135deg, #c9a84c, #b8943d); color: #13151c;
               font-family: var(--sans); font-weight: 700; font-size: 14px; cursor: pointer;
               transition: opacity .2s; margin-top: 4px; }
    .run-btn:hover { opacity: .88; }
    .run-btn:disabled { opacity: .5; cursor: not-allowed; }

    /* Summary cards */
    .summary-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; }
    .summary-card { background: var(--bg2); border: 1px solid var(--border); border-radius: var(--radius);
                    padding: 14px 16px; }
    .summary-val { font-size: 26px; font-weight: 800; }
    .summary-lbl { font-family: var(--mono); font-size: 9px; letter-spacing: .1em;
                   text-transform: uppercase; color: var(--dim); margin-top: 4px; }

    /* Filter bar */
    .filter-bar { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }
    .filter-btn { padding: 5px 14px; border-radius: 6px; border: 1px solid var(--border2);
                  background: var(--bg3); color: var(--muted); font-family: var(--mono);
                  font-size: 10px; cursor: pointer; transition: all .2s; }
    .filter-btn.active { background: var(--amber-dim); border-color: var(--amber); color: var(--amber); }
    .search-input { flex: 1; min-width: 180px; background: var(--bg3); border: 1px solid var(--border2);
                    border-radius: 6px; padding: 6px 10px; color: var(--text); font-family: var(--mono);
                    font-size: 11px; outline: none; }
    .search-input:focus { border-color: var(--amber); }

    /* Results table */
    .results-table { background: var(--bg2); border: 1px solid var(--border);
                     border-radius: var(--radius); overflow: auto; flex: 1; min-height: 0; }
    .results-table table { width: 100%; border-collapse: collapse; }
    .results-table th { background: var(--bg3); padding: 9px 14px; text-align: left;
                        font-family: var(--mono); font-size: 9px; letter-spacing: .1em;
                        text-transform: uppercase; color: var(--amber);
                        border-bottom: 1px solid var(--border); white-space: nowrap; }
    .results-table td { padding: 10px 14px; border-bottom: 1px solid var(--border); vertical-align: top; }
    .results-table tr:last-child td { border-bottom: none; }
    .results-table tr:nth-child(even) td { background: rgba(255,255,255,.01); }
    .conf-badge { padding: 2px 8px; border-radius: 4px; font-family: var(--mono);
                  font-size: 9px; font-weight: 700; white-space: nowrap; }
    .xml-path { font-family: var(--mono); font-size: 11px; color: #60a5fa; word-break: break-word; }
    .xml-type { font-family: var(--mono); font-size: 10px; color: var(--dim); }
    .required-badge { font-family: var(--mono); font-size: 9px; color: var(--red);
                      background: rgba(248,113,113,.1); padding: 1px 5px; border-radius: 3px; }
    .match-row { margin-bottom: 4px; }
    .match-num { font-family: var(--mono); font-size: 9px; color: var(--dim); margin-right: 4px; }
    .match-domain { font-family: var(--mono); font-size: 10px; color: #a78bfa; }
    .match-ref { font-family: var(--mono); font-size: 11px; color: var(--amber); }
    .match-score { font-family: var(--mono); font-size: 10px; color: var(--muted); }
    .match-desc { font-size: 11px; color: var(--dim); margin-top: 2px; }
    .explanation { font-size: 11px; color: var(--muted); font-style: italic;
                   background: var(--bg3); border-radius: 5px; padding: 6px 8px; margin-top: 4px; }

    /* Export buttons */
    .export-bar { display: flex; gap: 10px; }
    .export-btn { padding: 8px 18px; border-radius: 7px; border: 1px solid rgba(201,168,76,.3);
                  background: rgba(201,168,76,.08); color: var(--amber); font-family: var(--mono);
                  font-size: 11px; cursor: pointer; transition: all .2s; font-weight: 600; }
    .export-btn:hover { background: rgba(201,168,76,.18); border-color: var(--amber); }

    /* Loading */
    .loading-wrap { display: flex; flex-direction: column; align-items: center; justify-content: center;
                    flex: 1; gap: 16px; }
    .spinner { width: 40px; height: 40px; border: 3px solid var(--border2);
               border-top-color: var(--amber); border-radius: 50%;
               animation: spin 1s linear infinite; }
    @keyframes spin { to { transform: rotate(360deg); } }
    .progress-text { font-family: var(--mono); font-size: 12px; color: var(--muted); }

    /* Empty */
    .empty-wrap { display: flex; flex-direction: column; align-items: center; justify-content: center;
                  flex: 1; gap: 12px; color: var(--dim); padding: 48px; }
    .empty-icon { font-size: 48px; opacity: .3; }
    .empty-title { font-size: 18px; font-weight: 700; color: var(--muted); }
    .empty-hint { font-size: 13px; text-align: center; max-width: 360px; line-height: 1.6; }

    /* Error */
    .error-box { background: rgba(248,113,113,.08); border: 1px solid rgba(248,113,113,.3);
                 border-radius: 8px; padding: 14px 18px; color: var(--red); font-size: 13px; }
  `;

  if (!token) return <LoginScreen onLogin={handleLogin} />;

  return (
    <div className="app">
      <style>{STYLES}</style>

      {/* Topbar */}
      <div className="topbar">
        <div className="topbar-left">
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <img src={LOGO_WHITE} alt="STAR" style={{height:26,objectFit:"contain"}} />
            <span style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--muted)",letterSpacing:".06em"}}>Schema Mapper</span>
          </div>
          {fileName && (
            <div className="file-badge">📄 {fileName}</div>
          )}
        </div>
        <div className="topbar-right">
          {results && (
            <div className="export-bar">
              <button className="export-btn" onClick={exportCSV}>⬇ Export CSV</button>
            </div>
          )}
          <span className="topbar-email">{userEmail}</span>
          <button className="signout-btn" onClick={handleLogout}>Sign out</button>
        </div>
      </div>

      <div className="layout">
        {/* Sidebar */}
        <div className="sidebar">

          {/* Upload */}
          <div>
            <div className="section-title">1. Upload XML Schema</div>
            <input ref={fileRef} type="file" accept=".xsd,.xml" style={{display:"none"}}
              onChange={e => handleFile(e.target.files[0])} />
            <div className={`drop-zone${xsdContent ? " drag-over" : ""}`}
              onClick={() => fileRef.current?.click()}
              onDrop={handleDrop}
              onDragOver={e => e.preventDefault()}>
              <div className="drop-icon">{xsdContent ? "✅" : "📂"}</div>
              <div className="drop-text">{xsdContent ? fileName : "Drop .xsd file here"}</div>
              <div className="drop-hint">{xsdContent ? `${xsdContent.split("\n").length} lines loaded` : "or click to browse"}</div>
            </div>
            {xsdContent && (
              <div style={{marginTop:8,fontFamily:"var(--mono)",fontSize:10,color:"var(--dim)"}}>
                ✅ Components.xsd loaded automatically from STAR repository
              </div>
            )}
          </div>

          {/* Options */}
          <div>
            <div className="section-title">2. Options</div>

            <label className="ctrl-label">STAR Version</label>
            <select className="ctrl-select" value={version} onChange={e => setVersion(e.target.value)}
              style={{marginBottom:12}}>
              {versions.length > 0
                ? versions.map(v => <option key={v.version} value={v.version}>{v.display_label || v.version}</option>)
                : ["v1.2.0","v1.1.0","v1.0.0","main"].map(v => <option key={v} value={v}>{v}</option>)
              }
            </select>

            <label className="ctrl-label">Filter to API Domain (optional)</label>
            <select className="ctrl-select" value={domain} onChange={e => setDomain(e.target.value)}
              style={{marginBottom:12}}>
              <option value="">(all domains)</option>
              {domains.map(d => <option key={d.domain} value={d.domain}>{d.domain}</option>)}
            </select>

            <div className="toggle-row" style={{marginBottom:6}}>
              <button className={`toggle ${expandComponents ? "on" : ""}`} onClick={() => setExpandComponents(v => !v)} />
              <span className="toggle-label">🔍 Expand component types</span>
            </div>
            <div className="toggle-warn" style={{marginBottom:12}}>
              Recurse into Components.xsd types (DealerParty, Vehicle, etc.) · More fields, slower
            </div>

            <div className="toggle-row" style={{marginBottom:6}}>
              <button className={`toggle ${useClaude ? "on" : ""}`} onClick={() => setUseClaude(v => !v)} />
              <span className="toggle-label">AI explanations (Claude)</span>
            </div>
            <div className="toggle-warn">Adds ~2-3s per HIGH/MEDIUM match · Uses AI tokens</div>
          </div>

          {/* Run */}
          <div>
            <div className="section-title">3. Run Mapping</div>
            <button className="run-btn" onClick={runMapping}
              disabled={loading || !xsdContent.trim()}>
              {loading ? "Mapping…" : "🗺️ Map Fields →"}
            </button>
          </div>

          {/* Info */}
          <div style={{marginTop:"auto",paddingTop:16,borderTop:"1px solid var(--border)"}}>
            <div style={{fontFamily:"var(--mono)",fontSize:10,color:"var(--dim)",lineHeight:1.7}}>
              <div>⚡ Powered by Voyage AI + STAR RAG</div>
              <div>📦 Components.xsd auto-resolved</div>
              <div>🔒 Secured by AWS Cognito</div>
            </div>
          </div>
        </div>

        {/* Main content */}
        <div className="main">
          {error && <div className="error-box">❌ {error}</div>}

          {loading ? (
            <div className="loading-wrap">
              <div className="spinner" />
              <div className="progress-text">{progress || "Running mapping…"}</div>
              <div style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--dim)"}}>
                This may take 30-60 seconds depending on field count
              </div>
            </div>
          ) : results ? (<>

            {/* Summary */}
            <div className="summary-grid">
              <div className="summary-card">
                <div className="summary-val" style={{color:"var(--text)"}}>{results.total}</div>
                <div className="summary-lbl">Total Fields</div>
              </div>
              <div className="summary-card">
                <div className="summary-val" style={{color:CONFIDENCE_COLORS.HIGH.text}}>{results.summary.HIGH}</div>
                <div className="summary-lbl">High Confidence</div>
              </div>
              <div className="summary-card">
                <div className="summary-val" style={{color:CONFIDENCE_COLORS.MEDIUM.text}}>{results.summary.MEDIUM}</div>
                <div className="summary-lbl">Medium</div>
              </div>
              <div className="summary-card">
                <div className="summary-val" style={{color:CONFIDENCE_COLORS.NO_MATCH.text}}>{results.summary.NO_MATCH}</div>
                <div className="summary-lbl">No Match</div>
              </div>
            </div>

            {/* Filter bar */}
            <div className="filter-bar">
              {["ALL","HIGH","MEDIUM","LOW","NO_MATCH"].map(f => (
                <button key={f} className={`filter-btn ${filter===f?"active":""}`}
                  onClick={() => setFilter(f)}>
                  {f} {f !== "ALL" ? `(${results.summary[f] ?? 0})` : `(${results.total})`}
                </button>
              ))}
              <input className="search-input" placeholder="Search fields or properties…"
                value={search} onChange={e => setSearch(e.target.value)} />
              <div style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--dim)",whiteSpace:"nowrap"}}>
                {filteredResults.length} shown
              </div>
            </div>

            {/* Results table */}
            <div className="results-table">
              <table>
                <thead>
                  <tr>
                    <th style={{width:180}}>XML Field</th>
                    <th style={{width:90}}>Type</th>
                    <th style={{width:90}}>Confidence</th>
                    <th>Top STAR Matches</th>
                    {useClaude && <th style={{width:220}}>AI Explanation</th>}
                  </tr>
                </thead>
                <tbody>
                  {filteredResults.map((r, i) => {
                    const conf = CONFIDENCE_COLORS[r.confidence] || CONFIDENCE_COLORS.NO_MATCH;
                    return (
                      <tr key={i}>
                        <td>
                          <div className="xml-path">{r.xml_path}</div>
                          {r.required && <span className="required-badge">required</span>}
                          {r.is_component && !expandComponents && (
                            <span style={{fontFamily:"var(--mono)",fontSize:9,color:"#a78bfa",
                              background:"rgba(167,139,250,.1)",padding:"1px 6px",
                              borderRadius:3,marginLeft:4}}>component</span>
                          )}
                          {r.description && (
                            <div style={{fontSize:10,color:"var(--dim)",marginTop:3,lineHeight:1.4}}>
                              {r.description.slice(0,80)}
                            </div>
                          )}
                        </td>
                        <td className="xml-type">{r.xml_type?.split(":")?.pop() || "—"}</td>
                        <td>
                          <span className="conf-badge" style={{
                            background: conf.bg, border: `1px solid ${conf.border}`, color: conf.text
                          }}>{conf.label}</span>
                          <div style={{fontFamily:"var(--mono)",fontSize:10,color:"var(--dim)",marginTop:4}}>
                            {r.top_score > 0 ? r.top_score.toFixed(3) : "—"}
                          </div>
                        </td>
                        <td>
                          {(r.matches || []).map((m, j) => (
                            <div key={j} className="match-row">
                              <span className="match-num">#{j+1}</span>
                              <span className="match-domain">{m.domain}</span>
                              <span style={{color:"var(--dim)",margin:"0 4px"}}>/</span>
                              <span className="match-ref">{m.ref}</span>
                              <span className="match-score" style={{marginLeft:8}}>{m.score?.toFixed(3)}</span>
                              {m.description && (
                                <div className="match-desc">{m.description.slice(0,80)}</div>
                              )}
                            </div>
                          ))}
                          {(!r.matches || r.matches.length === 0) && (
                            <span style={{fontFamily:"var(--mono)",fontSize:11,color:"var(--dim)"}}>No match found</span>
                          )}
                        </td>
                        {useClaude && (
                          <td>
                            {r.explanation
                              ? <div className="explanation">{r.explanation}</div>
                              : <span style={{fontFamily:"var(--mono)",fontSize:10,color:"var(--dim)"}}>—</span>}
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

          </>) : (
            <div className="empty-wrap">
              <div className="empty-icon">🗺️</div>
              <div className="empty-title">STAR Schema Mapper</div>
              <div className="empty-hint">
                Upload a STAR XML Schema (.xsd) on the left, choose your options,
                and click <strong>Map Fields</strong> to instantly match XML fields
                to STAR JSON domain model properties.
              </div>
              <div style={{marginTop:16,fontFamily:"var(--mono)",fontSize:11,color:"var(--dim)",textAlign:"center",lineHeight:1.8}}>
                <div>✅ Components.xsd pre-loaded — $refs resolved automatically</div>
                <div>⚡ Powered by Voyage AI semantic embeddings</div>
                <div>🎯 Field-level matches with HIGH / MEDIUM / LOW confidence</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
